<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1"
    variant="outlined"
    @click="isActive = true"
  ></v-btn>
  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="300">
        <v-form @submit.prevent enctype="multipart/form-data" ref="form">
          <v-text-field
            v-model="formData.name"
            :rules="nameRules"
            label="الاسم"
          ></v-text-field>
          <v-text-field
            v-model="formData.description"
            :rules="descriptionRules"
            label="الوصف"
          ></v-text-field>
          <v-checkbox
            label="معفى من القطع"
            v-model="formData.isNoCut"
          ></v-checkbox>
          <v-checkbox
            label=" له خصم"
            v-model="formData.isDiscount"
          ></v-checkbox>
          <v-radio-group inline v-model="formData.discountType">
            <v-radio label="ثابت" value="fixed"></v-radio>
            <v-radio label="مئوي" value="percentage"></v-radio>
          </v-radio-group>
          <v-text-field
            type="number"
            v-model="formData.discount"
            :rules="discountRules"
            label="نسبة الخصم"
          ></v-text-field>
        </v-form>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="حفظ" @click="save"></v-btn>

        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["saveFunction", "item", "mode", "iconName"],
  data() {
    return {
      isActive: false,
      formData: {
        name: "",
        description: "",
        isNoCut: false,
        isDiscount: false,
        discountType: "fixed",
        discount: 0,
      },
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 25) || "Name must be less than 10 characters",
      ],
      discountRules: [(v) => (v && v >= 0) || "minimum is 0 "],
    };
  },
  methods: {
    async validate() {
      const { valid } = await this.$refs.form.validate();

      if (valid) alert("Form is valid");
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        this.saveFunction(this.formData, this.mode);

        this.isActive = false;
      }
    },
    close() {
      this.isActive = false;
    },
    checkChanged() {
      console.log("ccc", "check changed");
    },
  },
  watch: {
    isActive(value) {
      if (value) {
        if (this.mode == "edit") {
          this.formData = { ...this.item };
          this.formData.isNoCut = this.formData.isNoCut == 1 ? true : false;
          this.formData.isDiscount =
            this.formData.isDiscount == 1 ? true : false;
          console.log("formmmmm", this.formData);
        }
      }
    },
  },
  computed: {
    title() {
      if (this.mode == "add") return "إضافة مجموعة";
      return "تعديل مجموعة";
    },
  },
};
</script>
